import React from "react";

import styles from "./Loader.scss";

const Loader = () => {
  return (
    <div className={`swg-news-list-loader ${styles.ellipsisLoader}`}>
      <div />
      <div />
    </div>
  );
};

export default Loader;
